import { render } from "./Start.vue?vue&type=template&id=33d638cd&scoped=true"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=33d638cd&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d638cd"]])

export default __exports__